import { render, staticRenderFns } from "./Loan-details.vue?vue&type=template&id=2f4d8ff6&scoped=true"
import script from "./Loan-details.vue?vue&type=script&lang=js"
export * from "./Loan-details.vue?vue&type=script&lang=js"
import style0 from "./Loan-details.vue?vue&type=style&index=0&id=2f4d8ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d8ff6",
  null
  
)

export default component.exports